import React from 'react'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import { isIgnoredError } from './globalExceptions'

const {
  bugsnagKey: BUGSNAG_KEY,
  environment: { name: ENVIRONMENT_NAME },
} = APP_CONFIG

// HACK (tayo): global.groove_preferLocal is never set on invocation of this code
// so get the value directly from __NEXT_DATA__ private methods
const preferLocal =
  global.groove_preferLocal || global?.__NEXT_DATA__?.query?.preferLocal
// END HACK

// deliberately not checking for truthy value
// preferLocal has to have a value
if ([false, 'false'].includes(preferLocal)) {
  Bugsnag.start({
    apiKey: BUGSNAG_KEY,
    releaseStage: ENVIRONMENT_NAME,
    enabledReleaseStages: ['production', 'staging'],
    plugins: [new BugsnagPluginReact(React)],
    onError: event => {
      try {
        // https://docs.bugsnag.com/platforms/javascript/customizing-error-reports/#errors
        const bugsnagError = Array.isArray(event?.errors)
          ? event.errors[0]
          : null
        const { originalError } = event

        if (isIgnoredError(bugsnagError, originalError)) return false
      } catch (fatalError) {
        // eslint-disable-next-line no-console
        console.log(
          'Bugsnag onError threw another error. Suppressing this error to prevent original error from getting reported',
          fatalError
        )
      }

      return true
    },
  })
}

export default Bugsnag
